export default{
    setSearchingData(state, data) {
        state.searchingData.per_page = data.per_page
        state.searchingData.page = data.page
        state.searchingData.search = data.search
        state.searchingData.sort = data.sort
    },
    resetSearchingData(state, data){
        state.searchingData = {
            per_page: 10,
            page: 1,
            search: {
                tenant_name: '',
                tenant_group_name: ''
            },
            sort: {
                key: 'id',
                asc: true
            },
        }
    },

    setSelectTenant(state, data){
        state.selectedTenant = data;
    },

    resetSelectTenant(state, data){
        state.selectedTenant = [];
    },

    setTimeRangeDaily (state, data) {
        state.defaultParam.daily.date_start = data.start_date || null;
        state.defaultParam.daily.date_end = data.end_date || null;
    },
    setTimeRangeHourly (state, data) {
        state.defaultParam.hourly.datetime_start = data.start_datetime || null;
        state.defaultParam.hourly.datetime_end = data.end_datetime || null;
    },
}